import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCustomerPortal } from '../contexts/CustomerPortalContext';
import Icon from './AppIcon';

/**
 * CustomerPortalGuard - protects customer-facing portal routes.
 * Redirects unauthenticated visitors to /customer-portal-login.
 */
const CustomerPortalGuard = ({ children }) => {
  const { isAuthenticated, loading } = useCustomerPortal();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-3 text-muted-foreground">
          <Icon name="Loader2" size={28} color="currentColor" className="animate-spin" />
          <span className="text-sm">Loading portal…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/customer-portal-login" state={{ from: location }} replace />;
  }

  return children;
};

export default CustomerPortalGuard;
